import React from 'react';
import { Form } from 'react-bootstrap';
import InputFeedbackStyles from './CustomInputFeedback.module.scss';

type Props = {
  errorFeedback: string;
};

export const CustomInputFeedback: React.FC<Props> = ({ errorFeedback }) => {
  return (
    <Form.Control.Feedback className={InputFeedbackStyles.feedback} type="invalid">
      {errorFeedback}
    </Form.Control.Feedback>
  );
};
